<template>
  <div class="selectable-container">
    <div class="selectable-wrap">
      <swiper class="selectable-group" ref="swiperRef" :options="swiperOptions">
        <swiper-slide v-for="option in options" :key="option[keyCode]" :ref="`slideRef${option[keyCode]}`"
          class="slide-content selectable-item"
          :class="{ 'isSelected': isSelected(option), 'isDisabled': option.disabled }">
          <div class="outer" @click="toggleSelection(option)">
            <div class="inner">
              <slot :option="option" :category="category" :isActive="isSelected(option)"></slot>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="custom-button-prev swiper-button-prev">
      <svg-icon icon-class="matr1x_fire_role_weapon_list_arrow_left" class-name="arrow-svg left-svg"></svg-icon>
    </div>
    <div class="custom-button-next swiper-button-next">
      <svg-icon icon-class="matr1x_fire_role_weapon_list_arrow_right" class-name="arrow-svg right-svg"></svg-icon>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    category: String,
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: "",
    },
    keyCode: {
      type: String,
      default: "id"
    },
  },
  data() {
    return {
      selectedValue: "",
      swiperOptions: {
        observer: true,
        observeParents: true,
        autoplay: false,
        loop: false,
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 8,
        resistanceRatio: 0,
        navigation: {
          nextEl: ".custom-button-next",
          prevEl: ".custom-button-prev"
        }
      },
    }
  },
  mounted() { },
  methods: {
    toggleSelection(option) {
      this.selectedValue = option[this.keyCode];
      this.$emit('input', this.selectedValue); // emit to parent components
      this.$emit('weapon-click', option);
    },
    isSelected(option) {
      return this.selectedValue === option[this.keyCode];
    },
  },
  watch: {
    value: {
      handler(newSelected) {
        this.selectedValue = newSelected;
      },
      immediate: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>